import Layout from '@/layout'
const smsRouter = {
  path: '/sms',
  component: Layout,
  name: 'sms',
  meta: {
    title: '短信管理',
    icon: 'el-icon-s-comment',
    roles: ['root', 'market']
  },
  children: [
    {
      path: 'records',
      name: 'SmsRecords',
      component: () => import('@/views/sms/records'),
      meta: { title: '发送记录查询', icon: 'el-icon-search', noCache: false }
    },
    {
      path: 'market',
      name: 'SmsMarket',
      component: () => import('@/views/sms/marketingSms'),
      meta: { title: '短信营销', icon: 'el-icon-s-ticket', noCache: false }
    }
  ]
}
export default smsRouter
